import { axios } from '../utils'
import { Breadcrumb } from 'common/types/entities/api/window'
import { BreadCrumbParam } from 'common/types/params/breadcrumb'

export const fetchStoreBreadcrumbs = async (storeId: string): Promise<Breadcrumb[]> => {
  const result = await axios.get<Breadcrumb[]>(`/v1/channels/${storeId}/breadcrumbs`)
  return result && result.data ? result.data : []
}

export const fetchBranchBreadcrumbs = async (params: BreadCrumbParam): Promise<Breadcrumb[]> => {
  const result = await axios.get<Breadcrumb[]>(`/v1/branch/${params.branchId}/breadcrumbs`, {
    params,
  })
  return result && result.data ? result.data : []
}
